export default "__VITE_ASSET__hGVCiAWj__"